<template>
  <div v-if="!allEmptyFields">
    <!-- <Divider dividerSize="24" /> -->
    <h3
      v-if="panel.lbl && !panel.panel_id === 'lbl_tags_panel'"
      class="section-title"
    >
      {{ formatHtml(panel.lbl) }}
    </h3>
    <h3 v-else-if="!visibility(panel.rows)" class="section-title">
      {{ formatHtml(panel.lbl) }}
    </h3>

    <Divider v-if="panel.lbl" dividerSize="8" />
    <div
      v-else-if="panel.panel_id == 'noname' && panel.separated_panel"
      class="separated-panel"
    ></div>
    <div v-if="panel.panel_id === 'lbl_tags_panel'">
      <TagForm :candidateId="fields.id.value" :field="panel.rows[0][0]" />
    </div>

    <div v-else>
      <DetailViewGroupField
        v-for="item in panel.rows"
        :key="item.name"
        :item="item"
        :id="fields?.id?.value"
        :store-module="storeModule"
        :countId="countId"
        :rows-count="panel.rows.length"
        class="detail-row"
      />
    </div>
  </div>
</template>

<script>
import DetailViewGroupField from './DetailViewGroupField';
import Divider from 'Elements/Divider/Divider';
import TagForm from 'Elements/Tag/TagForm';
import { mixin } from '@/utils/mixins';
export default {
  mixins: [mixin],
  components: { DetailViewGroupField, Divider, TagForm },
  props: {
    panel: {
      type: Object,
      default: () => ({
        lbl: '',
        rows: []
      })
    },
    fields: {
      type: Object
    },
    storeModule: String,
    countId: String
  },
  methods: {
    visibility(rows) {
      if (Array.isArray(rows) && rows.length) {
        if (Array.isArray(rows[0]) && rows[0].length) {
          return rows[0][0].visibility;
        } else return true;
      } else return true;
    }
  },
  computed: {
    allEmptyFields() {
      if (this.panel.separated_panel) {
        return false;
      }
      //если панель с кнопками для Принятия\Отказа отклика, то скрываем ее,
      //она отрисовывается отдельно
      else if (this.panel.panel_id == 'lbl_status_buttons_panel') {
        return true;
      } else if (this.panel.rows && this.panel.rows.length) {
        return this.panel.rows.every(row => {
          row.every(field => {
            (field.name === null && field.lbl === null) ||
              (field.name == 'tags_ids' && field.value.length == 0);
          });
        });
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  margin: 0;
  color: $grey64;
  font-size: 16px;
  font-family: 'Roboto Medium';
  font-weight: 500;
  line-height: 24px;
}

div {
  text-align: left;
}

.separated-panel {
  margin-top: 32px;
  border-top: 1px solid $grey8;
  padding-top: 16px;
  margin-right: -24px;
  margin-left: -24px;
}

.detail-row {
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 16px;
  }
}
</style>
